import { render, staticRenderFns } from "./Snippets2.vue?vue&type=template&id=39e4d9c2&scoped=true"
import script from "./Snippets2.vue?vue&type=script&lang=js"
export * from "./Snippets2.vue?vue&type=script&lang=js"
import style0 from "./Snippets2.vue?vue&type=style&index=0&id=39e4d9c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e4d9c2",
  null
  
)

export default component.exports